var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStethoscopeThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 23,
    viewBox: "0 -960 960 960",
    width: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540-81q-112 0-186-78.5T280-347v-35q-85-11-142.5-75.711T80-610v-230h120v-40h60v140h-60v-40h-60v169.677Q140-539 189.5-489.5T310-440q71 0 120.5-49.5T480-610.323V-780h-60v40h-60v-140h60v40h120v230q0 87.578-57.5 152.289Q425-393 340-382v35q0 85 56.5 145.5T540-141q81 0 140.5-60.152T740-347.235V-424q-35-10-57.5-39T660-530q0-45.833 32.118-77.917 32.117-32.083 78-32.083Q816-640 848-607.917q32 32.084 32 77.917 0 38-22.5 67T800-424v77q0 111-76.5 188.5T540-81Zm229.825-399Q791-480 805.5-494.325q14.5-14.324 14.5-35.5Q820-551 805.675-565.5q-14.324-14.5-35.5-14.5Q749-580 734.5-565.675q-14.5 14.324-14.5 35.5Q720-509 734.325-494.5q14.324 14.5 35.5 14.5Zm.175-50Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeThin);
export default __webpack_public_path__ + "static/media/stethoscope_thin.028681225f4375543bc166f7e99e0aeb.svg";
export { ForwardRef as ReactComponent };